const imgs = document.querySelectorAll('img');

imgs.forEach((img) => {
  img.addEventListener('error', () => {
    img.src = `/${img.src}`;
  });
});
